<template>
  <b-container no-gutters fluid class="wrapper">
    <b-row>
      <div class="logoWrapper">

        <img v-if="getLogoURL!==null" width="200px" :src="getLogoURL">
        <template v-else>
          <div class="realmName">{{realmTitle}}</div>
          <img width="200px" src="../assets/supported_maix.png">
        </template>
        <!--            <img width="200px" :src="getLogoURL">-->
      </div>

      <div class="selectorsWrapper">
        <StudySelector :title="$t('STUDY')"/>
        <TimeSelector :disable="disableHeaderControls" :trend="false"/>
        <TimeSelector :disable="disableHeaderControls" :trend="true"/>
      </div>

      <div class="controlsWrapper">
        <ReportButton :disable="disableHeaderControls" :items="reportMenuItems" icon="file-alt" :title="$t('REPORT')"/>
        <ReportButton :disable="disableHeaderControls" :items="excelMenuItems" icon="table" :title="$t('EXCEL')"/>
        <ReportButton :items="userMenuItems" icon="user" :title="personName"/>

        <b-button class="logoutButton" variant="transparent" @click="onLogout">
          <v-icon scale="1" class="aok" name="table"></v-icon>
          <div>{{'LOGOUT' | i18n}}</div>
        </b-button>
      </div>

    </b-row>
  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import StudySelector from "./StudySelector";
import ReportButton from "./ReportButton";
import TimeSelector from "./TimeSelector";

export default {
  name: 'StratosHeader',

  components: {TimeSelector, StudySelector, ReportButton},


  computed: {
    ...mapGetters(['pages', 'realmTitle', 'studyName', 'reports', 'getLogoURL', 'showKeyIngressMenu']),
    ...mapState(['userIdentity', 'realmStructure']),

    disableHeaderControls() {
      return this.$route.meta.disableHeaderControls
    },

    personName() {
      return this.userIdentity ? this.userIdentity.personName : ""
    },

    reportMenuItems() {
      return this.reports.filter(report => report.type==='PDF_OVERVIEW')
    },

    excelMenuItems() {
      return this.reports.filter(report => report.type==='EXCEL_BENCHMARK' || report.type==='EXCEL_INTERVIEWS')
    },

    userMenuItems() {
      let items = [{title: this.$t('SETTINGS'), route: '/settings/' + this.studyName}]

      if (this.userIdentity.canEditUsers) {
        items.push({title: this.$t('USERS'), route: '/users/' + this.studyName})
      }

      if (this.showKeyIngressMenu) {
        items.push({title: "KeyIngress", route: '/keyingress/' + this.studyName})
      }


      return items
    }

  },

  methods: {
    onLogout() {
//      this.$cookies.remove('sessionId')
      this.$store.commit('logout')
      this.$router.push('/')
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  /*padding-left: 0;*/
  /*padding-right: 0;*/
  padding-top: 0;
  padding-bottom: 0;
  background-color: #767474;
}

.logoWrapper {
  height: 100%;
  width: 250px;
  background-color: #00325a;
  flex:0 0 auto;
  padding: 1em;
}

.selectorsWrapper {
  flex:1 1 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  justify-content: space-around;
  align-self: center;
}

.controlsWrapper {
  background-color: #00325a;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex:0 0 auto;
}

</style>

<style>
.realmName {
  color: white;
}

button.logoutButton {
  color: white;
}

</style>
